"use strict";

exports.__esModule = true;
exports.default = memoize;
var _has = _interopRequireDefault(require("./_has.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Memoize an expensive function by storing its results.
function memoize(func, hasher) {
  var _memoize = function memoize(key) {
    var cache = _memoize.cache;
    var address = '' + (hasher ? hasher.apply(this, arguments) : key);
    if (!(0, _has.default)(cache, address)) cache[address] = func.apply(this, arguments);
    return cache[address];
  };
  _memoize.cache = {};
  return _memoize;
}